import { useEffect, useState } from "react";
import axios from "../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { Button, Col, Dropdown, Form, Row, Modal, ProgressBar } from "react-bootstrap";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { ThreeDot } from "../../assets/images";
import moment from "moment/moment";
import APIKeyModal from "../admin-dashboard/userdetails/api-key-modal";
import Cropper from "react-easy-crop";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setJob } from "../../features/jobSlice";

export default function AddCorporateClient() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [inactiveConfirmModal, setInactiveConfirmModal] = useState(false);
  const [inactiveSuccessModal, setInactiveSuccessModal] = useState(false);
  const [inactiveType, setInactiveType] = useState("");
  const [clientToUpdate, setClientToUpdate] = useState(null);
  const [corporateMemberPlans, setCorporateMemberPlans] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    corporateType: "",
    firstName: "",
    lastName: "",
    corporateProductId: "",
    websitePrefixName: "",
    clientVideoLink: "",
  });
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedAreaPixelsForFavicon, setCroppedAreaPixelsForFavicon] = useState(null);
  const [cropModal, setCropModal] = useState(false);
  const [cropModalForFavicon, setCropModalForFavicon] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [imageSrcForFavicon, setImageSrcForFavicon] = useState(null);
  const [allClients, setAllClients] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState("");
  const [modalPassData, setModalPassData] = useState({
    uid: "",
    source: "",
  });
  const [apiKeyModal, setApiKeyModal] = useState(false);
  const [passwordShowHide, setpasswordShowHide] = useState(null);
  const [logo, setLogo] = useState(null);
  const [favicon, setFavicon] = useState(null);

  const [arriviaModalOpen, setArriviaModalOpen] = useState(false);
  const [lowCreditsModalOpen, setLowCreditsModalOpen] = useState(false);
  const [selectedArriviaClient, setSelectedArriviaClient] = useState(null);
  const [arriviaFormData, setArriviaFormData] = useState({
    APIUsername: "",
    APIPassword: "",
    arriviaDomain: "",
    liveMode: true
  });
  const [lowCreditsFromData, setLowCreditsFromData] = useState({
    lowCount:0,
    clientId:""
  });

  const [jobId, setJobId] = useState(null);

  useEffect(() => {
    getAllCorporateMemberPlans();
  }, []);

  useEffect(() => {
    getAllClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  useEffect(() => {
    if (!jobId) {
      return;
    }
    localStorage.setItem("jobId", jobId);
    dispatch(setJob({ jobId }));

  }, [jobId]);

  const getAllCorporateMemberPlans = () => {
    setLoading(true);
    axios
      .get("/corporate-client/get-corporate-membership-plans")
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setCorporateMemberPlans(res.data.data);
        } else {
          console.log("corporate member plans error", res);
        }
      })
      .catch((err) => {
        console.log("corporate member plans error", err);
        setLoading(false);
      });
  };

  const getAllClients = () => {
    setLoading(true);
    axios
      .get(
        `/corporate-client/get-corporate-clients?page=${page}&limit=${limit}&search=${search}`,
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const { clients, total } = res.data.data;
          setAllClients(clients);
          setTotal(total);
        } else {
          console.log("corporate clients error", res);
        }
      })
      .catch((err) => {
        console.log("corporate clients error", err);
        setLoading(false);
      });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    if (name === "corporateProductId") {
      const selectedPlan = corporateMemberPlans.find(
        (plan) => plan._id === value,
      );
      if (selectedPlan) {
        setFormData((prev) => ({
          ...prev,
          corporateType: selectedPlan.key,
          [name]: value,
        }));
      }
    } else {
      if (name === "websitePrefixName") {
        if (value.length > 63) {
          message.error("Website prefix name cannot exceed 63 characters");
          return;
        }
      }

      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("email", formData.email);
    data.append("firstName", formData.firstName);
    data.append("lastName", formData.lastName);
    data.append("corporateProductId", formData.corporateProductId);
    data.append("corporateType", formData.corporateType);
    data.append("websitePrefixName", formData.websitePrefixName);
    data.append("clientVideoLink", formData.clientVideoLink);
    if (logo) {
      data.append("clientLogo", logo);
    }
    if (favicon) {
      data.append("clientFavicon", favicon);
    }

    setLoading(true);

    axios
      .post("/user/client-registration-process", data)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setFormData({
            email: "",
            firstName: "",
            lastName: "",
            corporateProductId: "",
            corporateType: "",
            websitePrefixName: "",
            clientVideoLink: "",
          });
          setLogo(null);
          getAllClients();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        message.error(err.response?.data?.message || "Something went wrong");
        setLoading(false);
      });
  };

  const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };

  const handleOpenLowCreditsModal = (data) => {

    setLowCreditsFromData({
      lowCount: data?.clientSettings?.settings?.eascapeBucksCodeLowCount || 0,
      clientId:data?.userDetails?._id
    })
    setLowCreditsModalOpen(true)
    
  }

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.userDetails?.name,
    },
    {
      name: "Email",
      selector: (row) => row?.userDetails?.email,
    },
    {
      name: "UserName",
      selector: (row) => row?.userDetails?.userName,
    },
    {
      name: "Plan",
      selector: (row) => row?.membershipPlanDetails?.name,
    },
    {
      name: "Website Prefix",
      selector: (row) => row?.userDetails?.corporateClientWebsitePrefix,
    },
    {
      name: "Created At",
      selector: (row) =>
        moment(row?.userDetails?.createdAt).format("MM-DD-YYYY"),
    },
    {
      name: "API Key",
      selector: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-primary btn-sm ml-3"
            onClick={() => {
              setModalPassData({
                uid: row?.userDetails?._id,
                source: row?.userDetails?.source,
              });
              setApiKeyModal(true);
            }}
          >
            Get API Key
          </button>
        </div>
      ),
    },
    {
      name: "Password",
      selector: (row) => (
        <div>
          {passwordShowHide === row._id ? (
            <>
              <span>{row?.userDetails?.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row._id);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
      ),
    },

    {
      name: "Status",
      selector: (row) => (row?.userDetails?.status ? "Active" : "Inactive"),
    },

    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                handleToggleClick(row);
              }}
            >
              {row?.userDetails?.status ? "Inactive" : "Active"}
            </div>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                history.push('/corporate-member-list/' + row?.userDetails?._id);
              }}
            >
              View Member List
            </div>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                history.push('/corporate-invoice/' + row?.userDetails?._id);
              }}
            >
              Invoice
            </div>
            {["PLATINUM", "PLATINUM_PLUS"].includes(row.corporateType) && (
              <>
                <div
                  className="dropdown-item"
                  role="button"
                  onClick={() => {
                    handleOpenArriviaModal(row);
                  }}
                >
                  Add / Edit Arrivia Details
                </div>

              </>
            )}
            {["PLATINUM", "PLATINUM_PLUS", "GOLD_PLUS", "SILVER_PLUS"].includes(row.corporateType) && (
              <>
              <div
                className="dropdown-item"
                role="button"
                onClick={() => {
                  history.push('/corporate-graphics/' + row?.userDetails?._id);
                }}
              >
                Add / Edit Graphics
              </div>
              <div
                className="dropdown-item"
                role="button"
                onClick={() => {
                    handleOpenLowCreditsModal(row);
                  }}
              >
                Set low escape credits count
              </div>
              </>
            )}
            {["IGNITE"].includes(row.corporateType) && (
              <div
                className="dropdown-item"
                role="button"
                onClick={() => {
                  history.push('/client-wise-member-upload/' + row?.userDetails?._id + "/" + row.userDetails?.tviId);
                }}
              >
                Upload Member
              </div>
            )}
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  const toggleStatus = (id, type) => {
    setLoading(true);
    axios
      .patch(`/corporate-client/toggle-corporate-client-status/${id}/${type}`)
      .then((res) => {
        setLoading(false);
        console.log(res.data.data?.jobId, 'res.data');
        if (res.data.status) {
          if (res.data.data?.jobId) {
            setJobId(res.data.data.jobId);
          } else if (res.data.jobId) {
            setJobId(res.data.jobId);
          }

          if (type === "inactive") {
            setInactiveSuccessModal(true);
          } else {
            setInactiveSuccessModal(true);
          }
          getAllClients();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleToggleClick = (row) => {
    const type = row?.userDetails?.status ? "inactive" : "active";
    setInactiveType(type);
    if (type === "inactive") {
      setClientToUpdate({ id: row?.userDetails?._id, type });
      setInactiveConfirmModal(true);
    } else {
      setClientToUpdate({ id: row?.userDetails?._id, type });
      setInactiveConfirmModal(true);
      // toggleStatus(row?.userDetails?._id, type);
    }
  };

  const handleOpenArriviaModal = (row) => {
    console.log("row", row);
    setSelectedArriviaClient(row?.userDetails?._id);
    setArriviaFormData({
      APIUsername: row?.clientArriviaDetails?.APIUsername || "",
      APIPassword: row?.clientArriviaDetails?.APIPassword || "",
      arriviaDomain: row?.clientArriviaDetails?.arriviaDomain || "",
      liveMode: row?.clientArriviaDetails?.liveMode || false,
    });
    setArriviaModalOpen(true);
  };

  const handleArriviaChange = (e) => {
    const { name, value, type, checked } = e.target;
    setArriviaFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleArriviaSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(`/corporate-client/update-arrivia-details/${selectedArriviaClient}`, arriviaFormData)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message || "Arrivia details updated successfully");
          setArriviaModalOpen(false);
          getAllClients();
        } else {
          message.error(res.data.message || "Failed to update Arrivia details");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error(err.response?.data?.message || "Something went wrong");
      });
  };

  const getCroppedImg = (imageSrc, cropPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = cropPixels.width;
        canvas.height = cropPixels.height;
        console.log("cropPixels", cropPixels);

        ctx.drawImage(
          image,
          cropPixels.x,
          cropPixels.y,
          cropPixels.width,
          cropPixels.height,
          0,
          0,
          cropPixels.width,
          cropPixels.height
        );

        canvas.toBlob((blob) => {
          const file = new File([blob], `client_logo_${Date.now()}_${Math.random()}.png`, {
            type: "image/png",
          });
          resolve(file);
        }, "image/png"); // 🔥 keeps transparency
      };
    });
  };

  const getCroppedImgFavicon = (imageSrc, cropPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;

      image.onload = () => {
        const OUTPUT_SIZE = 50;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = OUTPUT_SIZE;
        canvas.height = OUTPUT_SIZE;

        ctx.drawImage(
          image,
          cropPixels.x,
          cropPixels.y,
          cropPixels.width,
          cropPixels.height,
          0,
          0,
          OUTPUT_SIZE,
          OUTPUT_SIZE
        );

        canvas.toBlob(
          (blob) => {
            const file = new File(
              [blob],
              `client_favicon_${Date.now()}_${Math.random()}.png`,
              {
                type: "image/png",
              }
            );

            resolve(file);
          },
          "image/png",
          1
        );
      };
    });
  };

  const handleLowCodeSubmit = (e) => {
    e.preventDefault();
    if(lowCreditsFromData?.clientId && lowCreditsFromData?.lowCount){
    setLoading(true);
    let data = {
      lowCount:lowCreditsFromData?.lowCount,
    }
    axios
      .post(`/corporate-client/low-credit-alert-settings/${lowCreditsFromData.clientId}`, data)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setLowCreditsFromData({
            lowCount: 0,
            clientId:""
          })
          setLowCreditsModalOpen(false)
          getAllClients();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        message.error(err.response?.data?.message || "Something went wrong");
        setLoading(false);
      });  

    }else{
 message.error("Please enter low credits count");     
    }
    
  }



  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      {apiKeyModal && (
        <APIKeyModal
          apiKeyModal={apiKeyModal}
          handleCloseApiKeyModal={() => {
            setApiKeyModal(false);
          }}
          uid={modalPassData.uid}
          source={modalPassData.source}
        />
      )}

      <Modal
        show={arriviaModalOpen}
        onHide={() => setArriviaModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add / Edit Arrivia Details</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleArriviaSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Live Mode</Form.Label>
              <Form.Control
                as="select"
                name="liveMode"
                value={arriviaFormData.liveMode}
                onChange={(e) => setArriviaFormData((prev) => ({ ...prev, liveMode: e.target.value === "true" }))}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>API Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="API Username"
                required
                name="APIUsername"
                value={arriviaFormData.APIUsername}
                onChange={handleArriviaChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>API Password</Form.Label>
              <Form.Control
                type="text"
                placeholder="API Password"
                required
                name="APIPassword"
                value={arriviaFormData.APIPassword}
                onChange={handleArriviaChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Arrivia Domain (without https://)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Arrivia Domain"
                required
                name="arriviaDomain"
                value={arriviaFormData.arriviaDomain}
                onChange={handleArriviaChange}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setArriviaModalOpen(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        show={lowCreditsModalOpen}
        onHide={() => setLowCreditsModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Set low escape credits count</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleLowCodeSubmit}>
          <Modal.Body>

            <Form.Group className="mb-3">
              <Form.Label>Low Count</Form.Label>
              <Form.Control
                type="number"
                placeholder="25"
                required
                name="lowCount"
                value={lowCreditsFromData.lowCount}
                onChange={(e) => {
                  setLowCreditsFromData((prev) => ({ ...prev, lowCount: e.target.value }));
                }}
              />
            </Form.Group>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setLowCreditsModalOpen(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Corporate Clients</h2>
            </div>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={4} className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      required
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      required
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      required
                      name="email"
                      value={formData.email}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Select Membership Plan</Form.Label>
                    <Form.Control
                      as="select"
                      placeholder="Select Membership Plan"
                      required
                      name="corporateProductId"
                      value={formData.corporateProductId}
                      onChange={handleOnChange}
                    >
                      <option value="">Select Membership Plan</option>
                      {corporateMemberPlans.map((plan) => (
                        <option key={plan._id} value={plan._id}>
                          {plan.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                {["SILVER_PLUS", "GOLD_PLUS", "PLATINUM_PLUS", "PLATINUM"].includes(
                  formData.corporateType,
                ) && (
                    <Col md={4} className="mb-3">
                      <Form.Group className="mb-3">
                        <Form.Label>Website Prefix</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Website Prefix"
                          required
                          name="websitePrefixName"
                          value={formData.websitePrefixName}
                          onChange={handleOnChange}
                        />
                      </Form.Group>
                    </Col>
                  )}

                {["PLATINUM", "PLATINUM_PLUS"].includes(
                  formData.corporateType,
                ) && (
                    <>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Video Link</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Video Link"
                            name="clientVideoLink"
                            value={formData.clientVideoLink}
                            onChange={handleOnChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Logo (size:200x200px)</Form.Label>
                          <Form.Control
                            type="file"
                            // required
                            name="clientLogo"
                            accept=".png, .jpeg, .jpg"
                            // onChange={(e) => {
                            //   const file = e.target.files[0];
                            //   if (file) {
                            //     const validTypes = [
                            //       "image/png",
                            //       "image/jpeg",
                            //       "image/jpg",
                            //     ];
                            //     if (!validTypes.includes(file.type)) {
                            //       message.error(
                            //         "Invalid file type. Only PNG, JPEG, and JPG are allowed.",
                            //       );
                            //       e.target.value = null;
                            //       setLogo(null);
                            //       return;
                            //     }
                            //     setLogo(file);
                            //   } else {
                            //     setLogo(null);
                            //   }
                            // }}
                            onChange={(e) => {
                              const file = e.target.files[0];

                              if (!file) return;

                              const reader = new FileReader();
                              reader.onload = () => {
                                setImageSrc(reader.result);
                                setCropModal(true); // 🔥 open modal
                              };
                              reader.readAsDataURL(file);
                            }}
                          />
                          {logo && (
                            <img
                              width={75}
                              height={75}
                              src={URL.createObjectURL(logo)}
                              alt="Logo Preview"
                            />
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Favicon (size:50x50px)</Form.Label>
                          <Form.Control
                            type="file"
                            // required
                            name="clientFavicon"
                            accept=".png, .jpeg, .jpg"
                            // onChange={(e) => {
                            //   const file = e.target.files[0];
                            //   if (file) {
                            //     const validTypes = [
                            //       "image/png",
                            //       "image/jpeg",
                            //       "image/jpg",
                            //     ];
                            //     if (!validTypes.includes(file.type)) {
                            //       message.error(
                            //         "Invalid file type. Only PNG, JPEG, and JPG are allowed.",
                            //       );
                            //       e.target.value = null;
                            //       setLogo(null);
                            //       return;
                            //     }
                            //     setLogo(file);
                            //   } else {
                            //     setLogo(null);
                            //   }
                            // }}
                            onChange={(e) => {
                              const file = e.target.files[0];

                              if (!file) return;

                              const reader = new FileReader();
                              reader.onload = () => {
                                setImageSrcForFavicon(reader.result);
                                setCropModalForFavicon(true); // 🔥 open modal
                              };
                              reader.readAsDataURL(file);
                            }}
                          />
                          {favicon && (
                            <img
                              width={75}
                              height={75}
                              src={URL.createObjectURL(favicon)}
                              alt="Logo Preview"
                            />
                          )}
                        </Form.Group>
                      </Col>

                    </>
                  )}






              </Row>

              <div className="sub_but">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>



            <Modal
              show={cropModal}
              onHide={() => setCropModal(false)}
              centered
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Crop Image</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div style={{ position: "relative", width: "100%", height: 400 }}>
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1} // 🔥 square crop
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={(croppedArea, croppedAreaPixels) => {
                      setCroppedAreaPixels(croppedAreaPixels);
                    }}
                  />
                </div>

                <div className="mt-3">
                  <label>Zoom:</label>
                  <input
                    type="range"
                    className="w-100"
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e) => setZoom(e.target.value)}
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={() => setCropModal(false)}>
                  Cancel
                </Button>

                <Button
                  variant="success"
                  onClick={async () => {
                    const croppedImage = await getCroppedImg(
                      imageSrc,
                      croppedAreaPixels
                    );

                    // ✅ (Optional) Compress after crop
                    // const compressed = await imageCompression(croppedImage, { maxSizeMB: 0.2 });

                    setLogo(croppedImage);
                    setCropModal(false);
                  }}
                >
                  Crop & Save
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Crop Modal For Favicon */}


            <Modal
              show={cropModalForFavicon}
              onHide={() => setCropModalForFavicon(false)}
              centered
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Crop Image</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div style={{ position: "relative", width: "100%", height: 400 }}>
                  <Cropper
                    image={imageSrcForFavicon}
                    crop={crop}
                    zoom={zoom}
                    aspect={1} // 🔥 square crop
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={(croppedArea, croppedAreaPixels) => {
                      setCroppedAreaPixelsForFavicon(croppedAreaPixels);
                    }}
                  />
                </div>

                <div className="mt-3">
                  <label>Zoom:</label>
                  <input
                    type="range"
                    className="w-100"
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e) => setZoom(e.target.value)}
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={() => setCropModalForFavicon(false)}>
                  Cancel
                </Button>

                <Button
                  variant="success"
                  onClick={async () => {
                    const croppedImage = await getCroppedImgFavicon(
                      imageSrcForFavicon,
                      croppedAreaPixelsForFavicon
                    );

                    // ✅ (Optional) Compress after crop
                    // const compressed = await imageCompression(croppedImage, { maxSizeMB: 0.2 });

                    setFavicon(croppedImage);
                    setCropModalForFavicon(false);
                  }}
                >
                  Crop & Save
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Confirm Inactive Modal */}
            <Modal
              show={inactiveConfirmModal}
              onHide={() => setInactiveConfirmModal(false)}
              centered
              backdrop="static"
            >
              {/* <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
              </Modal.Header> */}

              <Modal.Body className="text-center pb-4">
                <div className="mb-4">
                  <div style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#ffe8e8", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
                    {inactiveType === 'active' ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10 15H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4l-4 4z"></path>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ff4d4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                      </svg>
                    )}
                  </div>
                </div>
                <h4 style={{ fontWeight: 600, color: "#333", marginBottom: "15px" }}>Confirm Deactivation</h4>
                <p style={{ color: "#666", fontSize: "16px", marginBottom: "25px", padding: "0 15px" }}>
                  Are you sure you want to {inactiveType === 'active' ? 'activate' : 'deactivate'} this client? All associated members will also be {inactiveType === 'active' ? 'activated' : 'deactivated'} in the background.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <Button
                    variant="light"
                    className="px-4 py-2"
                    style={{ fontWeight: 500, border: "1px solid #ddd", borderRadius: "8px" }}
                    onClick={() => setInactiveConfirmModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="px-4 py-2 ml-2"
                    style={{ fontWeight: 500, borderRadius: "8px", backgroundColor: inactiveType === 'active' ? "#1890ff" : "#ff4d4f", borderColor: inactiveType === 'active' ? "#1890ff" : "#ff4d4f" }}
                    onClick={() => {
                      setInactiveConfirmModal(false);
                      if (clientToUpdate) {
                        toggleStatus(clientToUpdate.id, clientToUpdate.type);
                      }
                    }}
                  >
                    Yes, {inactiveType === 'active' ? 'activate' : 'deactivate'}
                  </Button>
                </div>
              </Modal.Body>
            </Modal>

            {/* Success Inactive Modal */}
            <Modal
              show={inactiveSuccessModal}
              onHide={() => setInactiveSuccessModal(false)}
              centered
              backdrop="static"
            >
              {/* <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
              </Modal.Header> */}
              <Modal.Body className="text-center pb-4">
                <div className="mb-4">
                  <div style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#e6f7ff", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#1890ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </div>
                </div>
                <h4 style={{ fontWeight: 600, color: "#333", marginBottom: "15px" }}>Status Updated Successfully</h4>
                <p style={{ color: "#666", fontSize: "16px", marginBottom: "25px", padding: "0 15px", lineHeight: "1.6" }}>
                  The client has been {inactiveType === 'active' ? 'activated' : 'deactivated'}. The status of associated members will update in the background. <br />
                  <strong style={{ color: "#1890ff" }}>Please check after 5-10 minutes...</strong>
                </p>
                <div className="d-flex justify-content-center">
                  <Button
                    variant="primary"
                    className="px-5 py-2"
                    style={{ fontWeight: 500, borderRadius: "8px" }}
                    onClick={() => setInactiveSuccessModal(false)}
                  >
                    Got it
                  </Button>
                </div>
              </Modal.Body>
            </Modal>

            <div className="cert_det_inner">
              <h2>Corporate Clients Lists</h2>

              <div className="filter_section">
                <div className="input-group filter_fields">
                  <div className="search_field">
                    <input
                      placeholder="Search here ..."
                      type="text"
                      id="form1"
                      className="form-control"
                      onChange={(e) => {
                        setQuery(e.target.value);
                      }}
                      value={query}
                    />
                  </div>

                  <Button
                    className="search_button"
                    variant="primary"
                    disabled={!query}
                    onClick={() => {
                      setSearch(query);
                      setPage(1);
                    }}
                  >
                    Search
                  </Button>

                  <Button
                    className="search_button"
                    variant="secondary"
                    disabled={!search}
                    onClick={() => {
                      setSearch("");
                      setQuery("");
                      setPage(1);
                    }}
                  >
                    Clear Filter
                  </Button>
                </div>
                {/* <div className="filter_btns">
                  <Button
                    className="btn btn-primary search_button"
                    onClick={() => {
                      setShowCSVModal(true);
                    }}
                  >
                    Export CSV
                  </Button>
                  <CSVLink
                    data={csvData}
                    headers={csvHeaders}
                    filename={`escape_bucks_products_code_${new Date().toISOString()}.csv`}
                    className="hidden"
                    id="csv-download-link"
                    target="_blank"
                  />
                </div> */}
              </div>

              <DataTable
                columns={columns}
                data={allClients}
                pagination
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
                paginationServer
                paginationTotalRows={total}
                paginationDefaultPage={page}
                paginationPerPage={limit}
                paginationRowsPerPageOptions={[20, 50, 100]}
                onChangeRowsPerPage={(limit) => {
                  setPage(1);
                  setLimit(limit);
                }}
                onChangePage={(page) => {
                  setPage(page);
                }}
                className={allClients.length === 1 ? "search_state" : ""}
              />
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
